var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowBigSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 305,
    viewBox: "0 0 383 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.702 39.74C313.18 52.6819 347.613 71.7893 366.66 101.117C385.708 130.444 389.371 169.992 370.873 197.154C352.374 224.315 311.715 239.145 277.344 254.087C242.973 268.973 214.951 284.081 178.504 294.579C142.057 305.132 97.2461 311.131 65.6832 295.357C34.1203 279.582 15.8663 242.089 6.76985 204.652C-2.32662 167.271 -2.32661 129.945 7.1972 93.0629C16.721 56.1812 35.7687 19.6884 67.3316 6.46875C98.8945 -6.80642 142.912 3.13607 180.213 11.5233C217.576 19.9106 248.162 26.7425 280.702 39.74Z",
    fill: "#FCA61F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBigSvg);
export default __webpack_public_path__ + "static/media/yellow-big-svg.509d834aaaf9e04aeb8452c90044f989.svg";
export { ForwardRef as ReactComponent };